module.exports = __webpack_public_path__ + "static/media/gamesPlayed_1000_5000.8eca3596.png";